import ActionButton from 'components/ActionButton';
import SearchBar from 'components/Autosuggest/Autosuggest';
import React, { useEffect, useState } from 'react';
import { searchItems } from 'services';
import styles from './index.module.scss';
import qs from 'query-string';
import MultiSelectDropdown from 'components/MultiSelectDropdown';
import { fetchAllCategories } from '../../../services/api/inventoryItems';
import { showError } from '../../../utils/notifications';
import _ from 'lodash';
import DropDown from 'components/FormFields/dropdown';
import NumberSlider from 'components/NumberSlider';
import { sortArray } from 'utils';

const PROMOTIONAL_OPTIONS = [{ value: '', name: 'ALL' }, { value: 'true', name: 'Promotional' }, { value: 'false', name: 'Non-Promotional' }];
const DELETED_ITEM_OPTIONS = [{ value: '', name: 'ALL' }, { value: 'true', name: 'Deleted' }, { value: 'false', name: 'Non-Deleted' }];
const FEATURED_ITEM_OPTIONS = [{ value: '', name: 'ALL' }, { value: 'true', name: 'Featured' }, { value: 'false', name: 'Non-Featured' }];
const MUST_HAVE_ITEM_OPTIONS = [{ value: '', name: 'ALL' }, { value: 'true', name: 'True' }, { value: 'false', name: 'False' }];
const ITEM_ADDRESS_EXISTS_OPTIONS = [{ value: '', name: 'ALL' }, { value: 'true', name: 'Exists' }, { value: 'false', name: 'Does Not Exists' }];
const EXCLUDED_FROM_HOME_BOX_OPTIONS = [{ value: '', name: 'ALL' }, { value: 'true', name: 'Included' }, { value: 'false', name: 'Exluded' }];
const DEFAULT_DELETE_FILTER = 'false';
const DEFAULT_QUANTITY = 500;

const Filter = props => {
  const [item, setItem] = useState<Record<string, any>>({});
  const [itemId, setItemId] = useState<string>('');
  const [categoryIds, setCategoryIds] = useState<any[]>([]);
  const [excludedFromHomeBox, setExcludedFromHomeBox] = useState<string>('false');
  const [active, setActive] = useState<string>('');
  const [showDeletedItems, setShowDeletedItems] = useState<string>(DEFAULT_DELETE_FILTER);
  const [isPromotional, setIsPromotional] = useState<any>('');
  const [isFeatured, setIsFeatured] = useState<string>('');
  const [mustHave, setMustHave] = useState<string>('');
  const [origin, setOrigin] = useState<string>('');
  const [categories, setCategories] = useState<{ label: string; value: string }[]>([]);
  const [itemAddressExists, setItemAddressExists] = useState<string>('');
  const [quantity, setQuantity] = useState<any>(DEFAULT_QUANTITY);

  const fetchAllCategoriesFn = async () => {
    try {
      const response = await fetchAllCategories();
      setCategories(response.map(cat => ({ label: cat.description, value: cat.objectId })));
    } catch (e) {
      showError(e);
    }
  };

  useEffect(() => {
    const {
      itemId,
      active,
      categoryIds,
      excludedFromHomeBox = '',
      deleted = 'false',
      itemAddressExists,
      max: quantityFromParams = DEFAULT_QUANTITY,
    } = qs.parse(props.location.search, { parseBooleans: true, parseNumbers: true });

    let _categoryIds: any[] = [];
    if (categoryIds) {
      _categoryIds = categories.filter(cat => categoryIds.toString().includes(cat.value));
    }

    setExcludedFromHomeBox(`${excludedFromHomeBox}`);
    setItemId(itemId?.toString() || '');
    setItemAddressExists(itemAddressExists?.toString() || '');
    setCategoryIds(_categoryIds || []);
    setShowDeletedItems(`${deleted}`);
    setQuantity(quantityFromParams);
    if (active !== undefined) {
      if (active) {
        setActive('active');
      } else {
        setActive('inactive');
      }
    }
    fetchAllCategoriesFn();
  }, []);

  const resetFilter = () => {
    setItem({});
    setItemId('');
    setActive('');
    setCategoryIds([]);
    setExcludedFromHomeBox('false');
    setShowDeletedItems(DEFAULT_DELETE_FILTER);
    setIsPromotional('');
    setIsFeatured('false');
    setMustHave('');
    setItemAddressExists('');
    setOrigin('');
    setQuantity(DEFAULT_QUANTITY);
    const filterData = {
      deleted: DEFAULT_DELETE_FILTER,
    };
    props.onSubmit(filterData);
  };

  const handleSubmit = () => {
    let filterData: Record<string, any> = {
      categoryIds: categoryIds?.length > 0 ? categoryIds.map(cat => cat.value).join('|') : '',
      itemId: item.id || itemId,
      deleted: showDeletedItems ? JSON.parse(showDeletedItems) : '',
      isFeatured: isFeatured ? JSON.parse(isFeatured) : '',
      mustHave: mustHave ? JSON.parse(mustHave) : '',
      itemAddressExists: itemAddressExists ? JSON.parse(itemAddressExists) : '',
      isPromotional: isPromotional ? JSON.parse(isPromotional) : '',
      excludedFromHomeBox: excludedFromHomeBox ? JSON.parse(excludedFromHomeBox) : '',
      origin: !origin ? undefined : origin,

    };
    if (quantity || quantity === 0) {
      filterData = { ...filterData, min: 0, max: quantity };
    }

    if (!!active.length && active !== 'all') {
      filterData = {
        ...filterData,
        active: active === 'active' ? true : false,
      };
    }
    filterData = _.omitBy(filterData, (v) => _.isUndefined(v) || _.isNull(v) || v === '');
    props.onSubmit(filterData);
  };

  const handleSuggestionClick = (suggestion: Record<string, any>) => {
    const item: Record<string, any> = {};
    item.id = suggestion.id;
    item.name = suggestion.displayName;
    setItem(item);
    setItemId(item.id);
  };

  return (
    <form className={styles['filter-container']} onSubmit={handleSubmit}>
      <div className={styles['autosuggest-group']}>
        <div className={styles['label']}>Inventory Item</div>
        <div className={styles['autosuggest-input']}>
          <SearchBar
            value={item.name || ''}
            setValue={value => setItem({ ...item, name: value })}
            searchAPI={searchItems}
            searchAPIParamKey={'term'}
            onSuggestionClicked={handleSuggestionClick}
          />
        </div>
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Inventory Item ID</div>
        <input
          className={'form-control'}
          value={itemId}
          onChange={e => setItemId(e.target.value)}
        />
      </div>
      <div className={styles['input-group']}>
        <div className={styles['label']}>Item Active</div>
        <select
          value={active}
          className={'form-control'}
          onChange={e => setActive(e.target.value)}
        >
          <option hidden={!!active} value={'default'}>Select</option>
          <option value={'all'}>All</option>
          <option value={'active'}>ACTIVE</option>
          <option value={'inactive'}>INACTIVE</option>
        </select>
      </div>

      <div className={styles['input-group']}>
        <div className={styles['label']}>Item Origin</div>
        <select
          value={origin}
          className={'form-control'}
          onChange={e => setOrigin(e.target.value)}
        >
          <option value={''}>All</option>
          <option value={'LOCAL'}>Local</option>
          <option value={'IMPORTED'}>Imported</option>
        </select>
      </div>

      <div className={`${styles['input-group']} ${styles['category-group']}`}>
        <div className={styles['label']}>Category</div>
        <MultiSelectDropdown
          value={categoryIds}
          options={sortArray(categories, 'label')}
          onChange={setCategoryIds}
          disableSearch={true}
        />
      </div>
      <div className={styles['input-group']}>
        <DropDown title="Excluded From Home Box" value={excludedFromHomeBox} onChange={setExcludedFromHomeBox} options={EXCLUDED_FROM_HOME_BOX_OPTIONS} />
      </div>
      <div className={styles['input-group']}>
        <DropDown title="Deleted Items" value={showDeletedItems} onChange={setShowDeletedItems} options={DELETED_ITEM_OPTIONS} />
      </div>
      <div className={styles['input-group']}>
        <DropDown title="Promotional Items" value={isPromotional} onChange={setIsPromotional} options={PROMOTIONAL_OPTIONS} />
      </div>
      <div className={styles['input-group']}>
        <DropDown title="Featured Items" value={isFeatured} onChange={setIsFeatured} options={FEATURED_ITEM_OPTIONS} />
      </div>
      <div className={styles['input-group']}>
        <DropDown title="Item Address Exists" value={itemAddressExists} onChange={setItemAddressExists} options={ITEM_ADDRESS_EXISTS_OPTIONS} />
      </div>
      <div className={styles['input-group']}>
        <DropDown title="Must Have Item" value={mustHave} onChange={setMustHave} options={MUST_HAVE_ITEM_OPTIONS} />
      </div>
      <div className={`${styles['input-group']} ${styles['quantity-range-group']}`}>
        <div className={styles['label']}>Quantity Range</div>
        <div className='d-flex flex-row justify-content-between'>
          <NumberSlider onChange={setQuantity} value={quantity} maxRange={500} />
        </div>
      </div>
      <div className={styles['buttons-container']}>
        <ActionButton
          text={'Reset'}
          active={true}
          isLoading={false}
          onClick={resetFilter}
        />
        <ActionButton
          text={'Submit'}
          active={true}
          isSubmit={true}
          isLoading={false}
          onClick={handleSubmit}
        />
      </div>
    </form>
  );
};

export default Filter;